import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { COLUMNS } from "./columnCust";
import Header from "../../layout/Header";
import Paginated from "./Paginated";
import { getSchemaList } from "../../../actions/auth";

function SchemaSetting() {
  const [formData, setFormData] = useState([]);
  const [response, setResponse] = useState([]);

  const [loader, setLoader] = useState(false);
  const updateData = () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    getSchemaList(token?.access_token).then((res) => {
      setResponse(res?.schema?.properties);
      setLoader(false);
    });
  };
  useEffect(() => {
    if (response) {
      const tempData = Object.keys(response)
        ?.filter((key) => key !== "password")
        ?.map((key) => {
          const field = response[key];
          const isCustomerCode = field.fielddisplayname === "Customer Code";

          return {
            ...field,
            fieldName: key,
            displayName: field.fielddisplayname,
            dataType: field.type,
            fielddatatype:
              field.fielddatatype === "Enumeration"
                ? field.enum?.join(", ")
                : field.fielddatatype,
            isident: field.isident === true ? "True" : "False",
            IsMobileField: field.isPhone === true ? "True" : "False",
            isFormView: field.isFormView === true ? "True" : "False",
            isrequired: field.isRequired === true ? "True" : "False",
            action: isCustomerCode ? (
              <span
                className="edit_btn"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  color: "#ccc",
                  cursor: "not-allowed",
                  pointerEvents: "none",
                }}
              >
                <i className="fa-solid fa-pen"></i>
              </span>
            ) : (
              <Link
                className="edit_btn"
                state={{ key, field }}
                to="/create-Schema"
                style={{ display: "flex", justifyContent: "center" }}
                csvalue="Edit"
              >
                <i className="fa-solid fa-pen"></i>
                <div className="show_div">Edit</div>
              </Link>
            ),
            // isSignUp: field.isSignUp === true ?"True" : "False",
            // isSignUp: field.isSignUp === true ?"True" : "False",
          };
        });

      setFormData(tempData);
    }
  }, [response]);

  useEffect(() => {
    updateData();
  }, []);

  const downloadCSV = () => {
    const csvHeaders = [
      "Field Name",
      "Display Name",
      "Data Type",
      "Field Data Type",
      "Is Ident",
      "Is Mobile Field",
      "Is Display",
      "Is Required",
    ];

    const escapeCsvValue = (value) => {
      const stringValue = value === undefined || value === null ? "" : String(value);
      return `"${stringValue.replace(/"/g, '""')}"`;
    };

    const csvRows = formData.map((row) =>
      [
        row.fieldName,
        row.displayName,
        row.dataType,
        row.fielddatatype,
        row.isident,
        row.IsMobileField,
        row.isFormView,
        row.isrequired,
      ].map(escapeCsvValue)
    );

    const csvContent = [csvHeaders.map(escapeCsvValue), ...csvRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "customer_schema.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <Header name={"Customer Schema"} />
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className="dashboard__heading">
                                <div className="dashboard__headingLeft">
                                    <div className="dashboard__headingContent">
                                        <Link to="/create-Schema">
                                            <Button id="voucher" className="btn btn-primary btn-lg">
                                                Create Customer Schema
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div> */}
            <div className="dashboard__customersCard">
              <div className="dashboard__header">
                <div className="dashboard__left">
                  <h4 id="voucher_details">Customer Schema Details</h4>
                </div>
                <div className="dashboard__right">
                  <button className="btn btn-default" onClick={downloadCSV}>
                    <i
                      class="fa-solid fa-download"
                      style={{ marginRight: "10px" }}
                    ></i>
                    Download
                  </button>
                </div>
              </div>
              <div className="dashboard__body">
                {" "}
                <Paginated data={formData ? formData : []} columns={COLUMNS} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SchemaSetting;
